import { Moon, Sun } from "lucide-react";
import { useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/admin/use-theme";

const systemIsDark = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-color-scheme: dark)").matches;

/**
 * One click switches between light and dark. The first click starts from
 * what the device shows (the "system" default), after that the choice is
 * kept in the store.
 */
export function ThemeModeToggle() {
  const { theme, setTheme } = useTheme();
  const translate = useTranslate();
  const isDark = theme === "dark" || (theme === "system" && systemIsDark());
  const label = translate(isDark ? "crm.theme.light" : "crm.theme.dark", {
    _: isDark ? "Light" : "Dark",
  });

  return (
    <Button
      variant="ghost"
      size="icon"
      className="hidden sm:inline-flex"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={label}
      title={label}
    >
      {isDark ? (
        <Sun className="h-[1.2rem] w-[1.2rem]" />
      ) : (
        <Moon className="h-[1.2rem] w-[1.2rem]" />
      )}
    </Button>
  );
}
